import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js"
flatpickr.localize(German); // default locale is now German
flatpickr.setDefaults({
    //static: true
})


import Vue from 'vue';
import VueFlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

Vue.use(VueFlatPickr);